/**
 * Product option plumbing for high-variant products and combined listings.
 * Uses Shopify's option_values Section Rendering API instead of scanning every
 * product variant in the browser.
 */
(function () {
  if (window.ProductOptions2026) return;

  var requests = new Map();

  function selectedControls(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('input[data-product-option]:checked, select[data-product-option]')
    );
  }

  function selectedValueIds(picker) {
    return selectedControls(picker)
      .map(function (control) {
        var item = control.tagName === 'SELECT'
          ? control.options[control.selectedIndex]
          : control;
        return item && item.dataset.optionValueId;
      })
      .filter(Boolean);
  }

  function selectedControl(control) {
    return control.tagName === 'SELECT'
      ? control.options[control.selectedIndex]
      : control;
  }

  function productForm(picker) {
    return picker.closest('form[action*="/cart/add"]');
  }

  function sizeIsPending(picker) {
    if (picker.dataset.requireSize !== 'true') return false;
    var control = picker.querySelector('[data-size-option] input:checked, [data-size-option] select');
    return !control || !control.value;
  }

  function clearSize(picker) {
    picker.querySelectorAll('[data-size-option] input').forEach(function (input) { input.checked = false; });
    var select = picker.querySelector('[data-size-option] select');
    if (select) select.value = '';
    var label = picker.querySelector('[data-size-option] [data-selected-option-value]');
    if (label) label.textContent = '';
    var summary = picker.querySelector('[data-size-option] [data-stamp-dropdown] summary');
    if (summary) {
      summary.querySelector('[data-stamp-selection]').textContent = 'Select size';
      summary.setAttribute('aria-label', summary.dataset.optionName + ': Select size');
    }
  }

  function updateButton(form, variantId, available, sizePending) {
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-to-cart], [name="add"]');
    if (idInput) {
      idInput.value = sizePending ? '' : variantId || '';
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!button) return;

    var addLabel = button.dataset.labelAdd || button.dataset.origText || button.textContent;
    var soldOutLabel = button.dataset.labelSoldout || 'Sold out';
    var unavailableLabel = button.dataset.labelUnavailable || 'Unavailable';
    button.dataset.origText = addLabel;
    form.dataset.sizePending = sizePending ? 'true' : 'false';
    button.disabled = sizePending || !variantId || !available || form.dataset.cartAdding === 'true';
    button.textContent = sizePending ? button.dataset.labelSelect || 'Select size' : !variantId ? unavailableLabel : available ? addLabel : soldOutLabel;
  }

  function contextualProductUrl(productUrl) {
    var page = new URL(window.location.href || window.location.pathname, window.location.origin);
    var url = new URL(productUrl || page.pathname, page);
    // Product links normally contain only a path. Keep the active template,
    // theme preview and campaign context when resolving another combination.
    var productParams = new Set(url.searchParams.keys());
    page.searchParams.forEach(function (value, key) {
      if (!productParams.has(key)) url.searchParams.append(key, value);
    });
    ['variant', 'option_values', 'section_id', 'sections'].forEach(function (key) {
      url.searchParams.delete(key);
    });
    if (!url.hash) url.hash = page.hash;
    return url;
  }

  function updateUrl(productUrl, variantId) {
    if (!history.replaceState) return;
    var url = contextualProductUrl(productUrl);
    if (variantId) url.searchParams.set('variant', variantId);
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }

  function announce(picker, message) {
    var status = picker.querySelector('[data-product-option-status]');
    if (status) status.textContent = message || '';
  }

  function hydratePicker(oldPicker, nextPicker, focusedId) {
    oldPicker.innerHTML = nextPicker.innerHTML;
    oldPicker.dataset.productUrl = nextPicker.dataset.productUrl || oldPicker.dataset.productUrl;
    oldPicker.dataset.selectedVariantId = nextPicker.dataset.selectedVariantId || '';
    oldPicker.dataset.selectedVariantAvailable = nextPicker.dataset.selectedVariantAvailable || 'false';
    oldPicker.dataset.selectedMediaId = nextPicker.dataset.selectedMediaId || '';
    oldPicker.dataset.selectedPrice = nextPicker.dataset.selectedPrice || '';
    if (focusedId) {
      var focused = document.getElementById(focusedId);
      if (focused) focused.focus({ preventScroll: true });
    }
  }

  function requestState(picker, control) {
    var item = selectedControl(control);
    if (!item) return;

    var currentProductUrl = picker.dataset.productUrl || window.location.pathname;
    var nextProductUrl = item.dataset.productUrl || currentProductUrl;
    var productChanged =
      item.dataset.productUrl &&
      new URL(nextProductUrl, location.origin).pathname !==
        new URL(currentProductUrl, location.origin).pathname;
    if (productChanged) {
      window.location.assign(contextualProductUrl(nextProductUrl).href);
      return;
    }

    var sectionId = picker.dataset.sectionId;
    var sizePending = sizeIsPending(picker);
    var ids = selectedValueIds(picker);
    var sectionRequestUrl = contextualProductUrl(nextProductUrl);
    sectionRequestUrl.hash = '';
    sectionRequestUrl.searchParams.set('section_id', sectionId);
    if (ids.length) sectionRequestUrl.searchParams.set('option_values', ids.join(','));
    var focusedId = control.id;
    var disclosure = control.closest('[data-stamp-dropdown]');
    if (disclosure) {
      var summary = disclosure.querySelector('summary');
      focusedId = summary.id;
      disclosure.open = false;
      summary.focus({ preventScroll: true });
    }
    var previous = requests.get(picker);
    if (previous) previous.abort();
    var request = new AbortController();
    requests.set(picker, request);
    var form = productForm(picker);
    var button = form?.querySelector('[data-add-to-cart], [name="add"]');
    var express = form?.querySelector('.shopify-dynamic-checkout');
    // Until the server resolves the whole combination, no provisional variant is purchasable.
    if (button) {
      button.dataset.origText = button.dataset.labelAdd || button.dataset.origText || button.textContent;
      button.disabled = true;
      button.textContent = 'Updating…';
      button.setAttribute('aria-busy', 'true');
    }
    var idInput = form?.querySelector('input[name="id"]');
    if (idInput) idInput.value = '';
    picker.dataset.selectedVariantId = '';
    picker.dataset.selectedVariantAvailable = 'false';
    if (form) form.dataset.optionsPending = 'true';
    if (express) express.inert = true;
    picker.querySelector('[data-product-option-retry]')?.setAttribute('hidden', '');

    picker.classList.add('is-updating');
    picker.setAttribute('aria-busy', 'true');
    announce(picker, 'Updating options');

    fetch(sectionRequestUrl.href, {
      credentials: 'same-origin',
      signal: request.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Option update failed');
        return response.text();
      })
      .then(function (text) {
        if (requests.get(picker) !== request || request.signal.aborted || !picker.isConnected) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var nextPicker = doc.querySelector('[data-product-option-picker]');
        if (!nextPicker) throw new Error('Option picker missing');

        var variantId = nextPicker.dataset.selectedVariantId;
        var available = !!variantId && nextPicker.dataset.selectedVariantAvailable === 'true';
        var form = productForm(picker);
        var currentRoot = picker.closest('[data-product-section]');
        var nextRoot = doc.querySelector('[data-product-section]');
        var currentPrice = currentRoot && currentRoot.querySelector('[data-product-price]');
        var nextPrice = nextRoot && nextRoot.querySelector('[data-product-price]');

        hydratePicker(picker, nextPicker, picker.contains(document.activeElement) ? focusedId : null);
        // A colour-only response must not silently choose a size for the shopper.
        if (sizePending) clearSize(picker);
        picker.dataset.sizePending = sizePending ? 'true' : 'false';
        if (currentPrice && nextPrice) currentPrice.innerHTML = nextPrice.innerHTML;
        updateButton(form, variantId, available, sizePending);
        if (form) delete form.dataset.optionsPending;
        if (!sizePending) updateUrl(nextProductUrl, variantId);
        announce(picker, sizePending ? 'Select size' : !variantId ? 'Selected combination is unavailable' : available ? 'Options updated' : 'Selected combination is sold out');
        document.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variantId: sizePending ? null : variantId || null,
            mediaId: nextPicker.dataset.selectedMediaId || null,
            available: available && !sizePending,
            sectionId: picker.dataset.sectionId || null
          }
        }));
      })
      .catch(function () {
        if (requests.get(picker) !== request || request.signal.aborted || !picker.isConnected) return;
        if (form) delete form.dataset.optionsPending;
        if (button) button.textContent = 'Options not loaded';
        announce(picker, 'Options could not be updated. Retry or choose another option.');
        picker.querySelector('[data-product-option-retry]')?.removeAttribute('hidden');
      })
      .finally(function () {
        if (requests.get(picker) !== request || request.signal.aborted) return;
        requests.delete(picker);
        picker.classList.remove('is-updating');
        picker.removeAttribute('aria-busy');
        if (button) button.removeAttribute('aria-busy');
        if (express) express.inert = form?.dataset.optionsPending === 'true' || form?.dataset.sizePending === 'true' || picker.dataset.selectedVariantAvailable !== 'true';
      });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-option-picker]').forEach(function (picker) {
      if (picker.dataset.productOptionsInit === 'true') return;
      picker.dataset.productOptionsInit = 'true';
      if (picker.dataset.sizePending === 'true') {
        clearSize(picker);
        updateButton(productForm(picker), null, false, true);
      }

      picker.addEventListener('click', function (event) {
        if (event.target.closest('[data-product-option-retry]')) {
          var control = selectedControls(picker)[0];
          if (control) requestState(picker, control);
        }
      });
      picker.addEventListener('change', function (event) {
        // Only shopper input may drive an option change. Scripts that replay
        // synthetic change events across every radio would otherwise walk the
        // picker through each value, flashing sold-out states on the way.
        if (!event.isTrusted) return;

        var control = event.target.closest('[data-product-option]');
        if (!control) return;

        var fieldset = control.closest('[data-option-position]');
        var value = control.value;
        var selectedLabel = fieldset && fieldset.querySelector('[data-selected-option-value]');
        if (selectedLabel) selectedLabel.textContent = value ? ': ' + value : '';

        requestState(picker, control);
      });
    });
  }

  // Companion controls resolve through the same picker and request queue.
  // Explicitly selecting one value avoids replaying synthetic change events.
  function choose(picker, position, value) {
    var fieldset = Array.from(picker.querySelectorAll('[data-option-position]')).find(function (field) { return field.dataset.optionPosition === String(position); });
    if (!fieldset) return false;
    var select = fieldset.querySelector('select[data-product-option]');
    var control = select || Array.from(fieldset.querySelectorAll('input[data-product-option]')).find(function (input) { return input.value === value; });
    var item = select ? Array.from(select.options).find(function (option) { return option.value === value; }) : control;
    if (!control || !item || item.disabled || !item.dataset.optionValueId) return false;
    if (select) select.value = value;
    else control.checked = true;
    var label = fieldset.querySelector('[data-selected-option-value]');
    if (label) label.textContent = ': ' + value;
    requestState(picker, control);
    return true;
  }
  window.ProductOptions2026 = { init: init, choose: choose };
  document.addEventListener('toggle', function (event) {
    var dropdown = event.target;
    if (!dropdown.matches?.('[data-stamp-dropdown]') || !dropdown.open) return;
    document.querySelectorAll('[data-stamp-dropdown][open]').forEach(function (other) {
      if (other !== dropdown) other.open = false;
    });
    var rect = dropdown.getBoundingClientRect();
    var below = window.innerHeight - rect.bottom;
    var list = dropdown.querySelector('.variant-grid');
    dropdown.toggleAttribute('data-open-up', below < Math.min(288, list.scrollHeight) && rect.top > below);
  }, true);
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-stamp-dropdown][open]').forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var dropdown = event.target.closest?.('[data-stamp-dropdown][open]');
    if (!dropdown) return;
    event.preventDefault();
    dropdown.open = false;
    dropdown.querySelector('summary').focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    requests.forEach(function (request, picker) {
      if (event.target.contains(picker)) { request.abort(); requests.delete(picker); }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
